import React from 'react';
import i18n from "../../../i18next";
import { connect } from 'react-redux';
import { Container, Row, Col, Button } from 'reactstrap';
import MaterialIcon from 'material-icons-react';

import ConfirmationScreen from '../settings/pos/ConfirmationScreen';
import SectionTitle from '../customerInsightScreen/SectionTitle';
import CommonMessage from '../customerInsightScreen/CommonMessage';
import { loadMarketingAutomations, setSelectedMarketingAutomation, deletePromotion } from '../../../actions/index';

class AutomationListScreen extends React.Component {

    state = {
        selectedPromotionId: null,
        deletePromotionConfirmationOpened: false,
    }

    componentDidMount = () => {
        const { id } = this.props.match.params;
        this.props.loadMarketingAutomations(id);
    }

    toggleConfirmationScreen = () => {
        this.setState({ ...this.state, deletePromotionConfirmationOpened: !this.state.deletePromotionConfirmationOpened });
    }

    deletePromotion = () => {
        let promotionId = this.state.selectedPromotionId;
        let restaurantId = this.props.match.params.id;

        this.props.deletePromotion(promotionId, () => {
            this.props.loadMarketingAutomations(restaurantId);
        });
    }

    openDeleteAutomationScreen = automation => {
        this.setState({ deletePromotionConfirmationOpened: true, selectedPromotionId: automation.id })
    }

    openSingleAutomationScreen = automation => {
        const { id } = this.props.match.params;
        this.props.setSelectedMarketingAutomation(automation, () => {
            this.props.history.push(`/restaurant/${id}/marketing-automation`);
        });
    }

    openNewAutomationScreen = () => {
        const { id } = this.props.match.params;
        this.props.setSelectedMarketingAutomation(null, () => {
            this.props.history.push(`/restaurant/${id}/marketing-automation`);
        });
    }

    renderAutomationStatus = automation => {

        const { activeStatus, inactiveStatus } = styles;

        return (
            <span style={automation.activeMarketingAutomation ? activeStatus : inactiveStatus}>
                {automation.activeMarketingAutomation ?
                    i18n.t('screens:marketingAutomationScreen.active') :
                    i18n.t('screens:marketingAutomationScreen.inactive')}
            </span>
        )
    }

    renderDescription = automation => {

        const { descriptionField } = styles;

        return (
            <div style={descriptionField} className="thinScrollbar">
                {automation.description}
            </div>
        );
    }

    renderAutomationSpecifics = automation => {

        let discountType;
        const notificationType = automation.notificationMethod === "EMAIL" ?
            i18n.t('screens:marketingAutomationScreen.emailNotification') :
            i18n.t('screens:marketingAutomationScreen.smsNotification');
        const notificationFrequency = automation.notificationFrequency.notificationMethodType === "ONCE_FUTURE" ?
            i18n.t('screens:marketingAutomationScreen.singleNotification') :
            i18n.t('screens:marketingAutomationScreen.repeatNotification');

        switch (automation.discountType) {
            case "PRICE_DISCOUNT":
                discountType = i18n.t('screens:customerInsightScreen.priceDiscount');
                break;
            case "FREE_PRODUCT":
                discountType = i18n.t('screens:customerInsightScreen.freeProduct');
                break;
            case "COMBO_DEAL":
                discountType = i18n.t('screens:customerInsightScreen.comboDeal');
                break;
            default:
                break;
        }

        return (
            <div style={{ paddingTop: '10px' }}>
                {this.renderAutomationOption(discountType)}
                {this.renderAutomationOption(notificationType)}
                {this.renderAutomationOption(notificationFrequency)}
            </div>
        );
    }

    renderAutomationOption = text => {

        const { grayBadge } = styles;

        return (
            <div>
                <div style={grayBadge}>
                    {text}
                </div>
            </div>
        );
    }

    renderAudienceWithButtons = automation => {

        const { bottomDiv, customerCount } = styles;

        return (
            <div style={bottomDiv}>
                {this.renderAudienceCount(automation)}
                {this.renderEditDeleteButtons(automation)}
            </div>
        );
    }

    renderAudienceCount = automation => {

        const { customerCount, additionalCount, numberCount } = styles;

        return (
            <div style={{ display: 'flex', paddingLeft: '5px', paddingTop: '10px' }}>
                <MaterialIcon icon='groups' size={30} color={'black'} />
                <div>
                    <div style={customerCount}>
                        {`${automation.totalCustomerCount} ${i18n.t('screens:marketingAutomationScreen.totalCustomers')}`}
                    </div>
                    <div style={additionalCount}>
                        <span style={numberCount}>{automation.activeCustomerCount}</span> {` ${i18n.t('screens:marketingAutomationScreen.activeCustomers')}`}
                    </div>
                    <div style={additionalCount}>
                        <span style={numberCount}>{automation.redeemedCustomerCount}</span> {` ${i18n.t('screens:marketingAutomationScreen.redemptionCount')}`}
                    </div>
                    <div style={additionalCount}>
                        <span style={numberCount}>{`${automation.redeemedPercentage}%`}</span> {` ${i18n.t('screens:marketingAutomationScreen.redemptionPercentage')}`}
                    </div>
                </div>
            </div>
        );
    }

    renderEditDeleteButtons = automation => {

        return (
            <div style={{ display: 'flex' }}>
                <div style={{ marginRight: '5px', display: 'flex', alignItems: 'flex-end' }}>
                    <div style={{ cursor: 'pointer' }} onClick={() => this.openSingleAutomationScreen(automation)}>
                        <MaterialIcon icon='create' size={40} color={'#0680c4'} />
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <div style={{ cursor: 'pointer' }} onClick={() => this.openDeleteAutomationScreen(automation)}>
                        <MaterialIcon icon='delete' size={40} color={'#0680c4'} />
                    </div>
                </div>
            </div>
        );
    }

    renderSingleAutomation = (automation, index) => {

        const { cardOutlines, header, contentSpacing } = styles;

        return (
            <Col sm={4} style={{ padding: '10px' }}>
                <div key={index} style={cardOutlines} >
                    <div style={header}>
                        <SectionTitle title={automation.name} />
                        {this.renderAutomationStatus(automation)}
                    </div>
                    <div style={contentSpacing}>
                        {this.renderDescription(automation)}
                        {this.renderAutomationSpecifics(automation)}
                        {this.renderAudienceWithButtons(automation)}
                    </div>
                </div>
            </Col>
        );
    }

    renderAutomations = () => {

        const automations = this.props.marketingAutomations.triggers;
        return automations.map((automation, index) => {
            return (
                <React.Fragment>
                    {this.renderSingleAutomation(automation, index)}
                </React.Fragment>
            );
        })
    }

    renderCreateButton = () => {

        const { createButton } = styles;

        return (
            <div style={{ padding: '10px' }}>
                <Button style={createButton} block color="primary" onClick={() => this.openNewAutomationScreen()}>
                    {`+ ${i18n.t('screens:marketingAutomationScreen.create')}`}
                </Button>
            </div>

        );
    }

    renderAutomationList = () => {

        const { mainContainer, rowStyle, colStyle } = styles;
        const textData = {
            header: i18n.t('screens:marketingAutomationScreen.deleteAutomation'),
            firstRow: i18n.t('screens:marketingAutomationScreen.deleteAutomationConfirmation'),
        };

        return (
            <React.Fragment>
                <Container fluid style={mainContainer}>
                    <Row style={rowStyle}>
                        <Col sm={11} style={colStyle}>
                            <Row style={{ margin: 0 }}>
                                {this.renderAutomations()}
                            </Row>
                        </Col>
                        <Col sm={1} style={colStyle}>
                            {this.renderCreateButton()}
                        </Col>
                    </Row>
                </Container>
                <ConfirmationScreen
                    isOpen={this.state.deletePromotionConfirmationOpened}
                    onToggle={this.toggleConfirmationScreen}
                    onSave={this.deletePromotion}
                    message={textData}
                />
            </React.Fragment>
        );
    }

    render() {

        if (this.props.marketingAutomations.marketingAutomationEnabled === null) {
            return null;
        } else if (this.props.marketingAutomations.marketingAutomationEnabled) {
            return this.renderAutomationList();
        } else {
            return <CommonMessage message={i18n.t('screens:customerInsightScreen.customerInsightDisabled')} />;
        }
    }
}

const mapStateToProps = state => {
    return {
        marketingAutomations: state.marketingAutomations
    }
};

export default connect(mapStateToProps, { loadMarketingAutomations, setSelectedMarketingAutomation, deletePromotion })(AutomationListScreen);

const styles = {
    mainContainer: {
        backgroundColor: '#ebf0f4',
        padding: '0',
        marginTop: '10px'
    },
    rowStyle: {
        margin: '0',
    },
    colStyle: {
        padding: 0
    },
    cardOutlines: {
        backgroundColor: 'white'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    activeStatus: {
        fontWeight: 'bold',
        color: '#71c672',
        paddingRight: '10px',
        paddingTop: '5px'
    },
    inactiveStatus: {
        fontWeight: 'bold',
        color: '#f42d23',
        paddingRight: '10px',
        paddingTop: '5px'
    },
    contentSpacing: {
        padding: '15px 20px 10px 20px'
    },
    descriptionField: {
        height: '50px',
        overflowY: 'auto',
        overflowX: 'hidden'
    },
    grayBadge: {
        display: 'inline-block',
        backgroundColor: '#f2f2f2',
        borderRadius: '15px',
        marginBottom: '5px',
        padding: '2px 10px 2px 10px',
        fontSize: '14px',
        fontWeight: 'bold'
    },
    bottomDiv: {
        paddingTop: '20px',
        display: 'flex',
        justifyContent: 'space-between'
    },
    customerCount: {
        fontWeight: 'bold',
        color: '#71c672',
        padding: '3px 0 0 10px'
    },
    createButton: {
        fontSize: '18px'
    },
    additionalCount: {
        paddingLeft: '10px',
        fontSize: '13px',
        fontWeight: 'bold'
    },
    numberCount: {
        fontSize: '14px'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/marketingAutomations/AutomationListScreen.js